export default {
  bannerContactData: {
    es: [{
      name: 'contact',
      imageBanner: '/assets/images/logos/logo-awards/GPTW_Banners.webp',
      imageDesktopXL: '/assets/images/contact/banner-contact-desktop-xl.webp',
      imageDesktop: '/assets/images/contact/banner-contact-desktop.webp',
      imageTablet: '/assets/images/contact/banner-contact-mobile.webp',
      imageMobile: '/assets/images/contact/banner-contact-mobile.webp',
      altImage: 'Contacta con nosotros',
      text1: '',
      text2: '¡Contacta con',
      text3: 'nosotros!',
      buttonText: '',
      buttonLink: '',
      buttonTarget: '',
    }],
    en: [{
      name: 'contact',
      imageBanner: '/assets/images/logos/logo-awards/GPTW_Banners.webp',
      imageDesktopXL: '/assets/images/contact/banner-contact-desktop-xl.webp',
      imageDesktop: '/assets/images/contact/banner-contact-desktop.webp',
      imageTablet: '/assets/images/contact/banner-contact-mobile.webp',
      imageMobile: '/assets/images/contact/banner-contact-mobile.webp',
      altImage: 'Contact us',
      text1: '',
      text2: 'Contact',
      text3: 'us!',
      buttonText: '',
      buttonLink: '',
      buttonTarget: '',
    }],
  },
};
